export default {
  STATUS: {
    ACTIVE: {
      NAME: "active",
      COLOR: "#5CB85C"
    },
    AD_HOC: {
      NAME: "ad hoc",
      COLOR: "#33AADB"
    },
    CLOSED: {
      NAME: "closed",
      COLOR: "#AA8A35"
    },
    DATE_CHANGED: {
      NAME: "date changed",
      COLOR: "#1344BE"
    },
    DATE_CONFIRMED: {
      NAME: "date confirmed",
      COLOR: "#476695"
    },
    DONE: {
      NAME: "done",
      COLOR: "#AA8A35"
    },
    EXPIRED: {
      NAME: "expired",
      COLOR: "#f5365c"
    },
    EXPIRING: {
      NAME: "expiring",
      COLOR: "#FFBA00"
    },
    HQ_TO_REVIEW: {
      NAME: "hq to review",
      COLOR: "#2189B4"
    },
    HQ_UPDATED: {
      NAME: "hq updated",
      COLOR: "#8965e0"
    },
    MINUTES_TIME: {
      NAME: "minutes time",
      COLOR: "#FFBA00"
    },
    NEED_ATTENTION: {
      NAME: "need attention",
      COLOR: "#f5365c"
    },
    NEED_ATTENTION_2: {
      NAME: "need attention!",
      COLOR: "#8965e0"
    },
    NEW: {
      NAME: "new",
      COLOR: "#08B023"
    },
    NEW_FY: {
      NAME: "new fy",
      COLOR: "#5CB85C"
    },
    NEW_REPLY: {
      NAME: "new reply",
      COLOR: "#33AADB"
    },
    NEW_UPDATES: {
      NAME: "new updates",
      COLOR: "#5CB85C"
    },
    OPEN: {
      NAME: "open",
      COLOR: "#FFBA00"
    },
    PENDING: {
      NAME: "pending",
      COLOR: "#33AADB"
    },
    READY: {
      NAME: "ready",
      COLOR: "#49D341"
    },
    REPLIED_WITH_UPDATE: {
      NAME: "replied w update",
      COLOR: "#5CB85C"
    },
    REQUEST_FOR_EXTENSION: {
      NAME: "request for extension",
      COLOR: "#33AADB"
    },
    SITE_ACKNOWLEDGED: {
      NAME: "site acknowledged",
      COLOR: "#5B527D"
    },
    SERVICE_VENDOR: {
      NAME: "service vendor",
      COLOR: "#13412C"
    },
    SOLVED: {
      NAME: "solved",
      COLOR: "#AA8A35"
    },
    TASK: {
      NAME: "task",
      COLOR: "#F21975"
    },
    UPDATE_STATUS_NOW: {
      NAME: "update status now!",
      COLOR: "#f5365c"
    },
    WAITING: {
      NAME: "waiting",
      COLOR: "#FFBA00"
    }
  },
  PROGRESS: {
    TAKEN_BY_HQ: {
      NAME: "Taken by HQ",
      COLOR: "info"
    }
  },
  DRI: {
    SITE: {
      NAME: "Site",
      COLOR: "#33AADB"
    }
  },
  MINI_DASHBOARD: {
    NEW: {
      COLUMN: "type",
      NAME: "new",
      DISPLAY_NAME: "new type",
      COLOR: "#5CB85C",
      LEGEND: "#08B023"
    },
    STARTED: {
      COLUMN: "status",
      NAME: "started",
      DISPLAY_NAME: "started",
      COLOR: "#f5365c",
      LEGEND: "#D32749"
    },
    EXPIRING: {
      COLUMN: "status",
      NAME: "expiring",
      DISPLAY_NAME: "expiring",
      COLOR: "#FFBA00",
      LEGEND: "#DCA510"
    },
    PENDING_QUOTATIONS: {
      COLUMN: "progress",
      NAME: "invited for quotations",
      DISPLAY_NAME: "pending quotations",
      COLOR: "#33AADB",
      LEGEND: "#2189B4"
    },

  }
};
